import * as React from 'react';

function SvgJoinedTab(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>{/* <style>{`.joined_tab_svg__prefix__cls-2{fill:${props.fill}`}</style> */}</defs>
      <g id="joined_tab_svg__prefix__joined" transform="translate(-236 -768)">
        <path
          id="joined_tab_svg__prefix__Rectangle_329"
          d="M0 0h24v24H0z"
          data-name="Rectangle 329"
          transform="translate(236 768)"
          fill="none"
        />
        <g
          id="joined_tab_svg__prefix__award_4_"
          data-name="award (4)"
          transform="translate(194.635 769)"
        >
          <g
            id="joined_tab_svg__prefix__Group_401"
            data-name="Group 401"
            transform="translate(44.365)"
          >
            <path
              id="joined_tab_svg__prefix__Path_1163"
              d="M101.015 310.438h-10.59a1.824 1.824 0 010-3.649h.563v-.572a4.732 4.732 0 019.464 0v.572h.563a1.824 1.824 0 010 3.649zm-10.59-2.366a.542.542 0 000 1.084h10.59a.542.542 0 000-1.084h-1.2a.641.641 0 01-.641-.641v-1.213a3.45 3.45 0 00-6.9 0v1.213a.641.641 0 01-.641.641z"
              className="joined_tab_svg__prefix__cls-2"
              data-name="Path 1163"
              transform="translate(-86.72 -288.663)"
            />
            <path
              id="joined_tab_svg__prefix__Path_1164"
              d="M141.2 427.492h-5.354a.641.641 0 110-1.282h5.354a.641.641 0 010 1.282z"
              className="joined_tab_svg__prefix__cls-2"
              data-name="Path 1164"
              transform="translate(-131.341 -408.084)"
            />
            <path
              id="joined_tab_svg__prefix__Path_1165"
              d="M115.566 13.895a6.245 6.245 0 01-6.238-6.238V1.474A1.476 1.476 0 01110.8 0h9.527a1.476 1.476 0 011.473 1.474V3.8a.641.641 0 11-1.282 0V1.474a.192.192 0 00-.192-.192H110.8a.192.192 0 00-.192.192v6.183a4.956 4.956 0 109.911 0 .641.641 0 111.282 0 6.245 6.245 0 01-6.235 6.238z"
              className="joined_tab_svg__prefix__cls-2"
              data-name="Path 1165"
              transform="translate(-106.565)"
            />
            <path
              id="joined_tab_svg__prefix__Path_1166"
              d="M375.122 79.939a.642.642 0 01-.62-.806l.762-2.857a.638.638 0 00-.616-.8h-1.483a.641.641 0 110-1.282h1.483a1.92 1.92 0 011.855 2.415l-.762 2.857a.641.641 0 01-.619.473z"
              className="joined_tab_svg__prefix__cls-2"
              data-name="Path 1166"
              transform="translate(-358.568 -71.036)"
            />
            <path
              id="joined_tab_svg__prefix__Path_1167"
              d="M45.811 79.937a.641.641 0 01-.619-.476L44.43 76.6a1.92 1.92 0 011.855-2.415h1.043a.641.641 0 010 1.282h-1.042a.638.638 0 00-.616.8l.762 2.857a.642.642 0 01-.62.807z"
              className="joined_tab_svg__prefix__cls-2"
              data-name="Path 1167"
              transform="translate(-44.365 -71.034)"
            />
            <rect
              id="joined_tab_svg__prefix__Rectangle_337"
              width={7.5}
              height={1.5}
              className="joined_tab_svg__prefix__cls-2"
              data-name="Rectangle 337"
              rx={0.75}
              transform="translate(5.5 5.775)"
            />
            <rect
              id="joined_tab_svg__prefix__Rectangle_338"
              width={7.5}
              height={1.5}
              className="joined_tab_svg__prefix__cls-2"
              data-name="Rectangle 338"
              rx={0.75}
              transform="rotate(90 3.612 6.388)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgJoinedTab;
